module.exports = __webpack_public_path__ + "img/FW_Wingsword.a6f1a746.png";